import { apiSlice } from "../api/apiSlice";

export const projectsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProjects: builder.query({
      query: (email) =>
        `/projects?teamMember=${email}&_sort=timestamp&_order=desc`,
    }),
    addProjects: builder.mutation({
      query: ({ data }) => ({
        url: "/projects",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        // optimistic cache update start
        let email = arg.data.teamMember;
        const pathResult = dispatch(
          apiSlice.util.updateQueryData("getProjects", email, (draft) => {
            draft.unshift({
              ...arg.data,
              id: draft.length + 1,
            });
          })
        );
        // optimistic cache update end
        try {
        } catch (error) {
          pathResult.undo();
        }
      },
    }),
  }),
});

export const { useGetProjectsQuery, useAddProjectsMutation } = projectsApi;
